/**
 * Biblioteca de proyectos guardados en el navegador.
 *
 * "Guardar" y "Abrir" usan esta lista interna a propósito: el operador trabaja
 * varios recintos en una jornada y no tiene por qué llenar su carpeta de
 * Descargas. La exportación a `.json` existe aparte, para respaldo o para pasar
 * un proyecto a otro computador.
 *
 * OJO: `localStorage` es por navegador y por dominio. No es un repositorio
 * compartido — si el operador cambia de máquina o le limpian el perfil, los
 * proyectos se pierden. Ver docs/hallazgos.md.
 */

import { STORAGE_KEYS } from '../config.js';

function readAll() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEYS.library)) || {};
  } catch {
    return {};
  }
}

function writeAll(entries) {
  try {
    localStorage.setItem(STORAGE_KEYS.library, JSON.stringify(entries));
    return true;
  } catch {
    return false;
  }
}

/** Proyectos guardados, del más reciente al más antiguo. */
export function listProjects() {
  const entries = readAll();
  return Object.keys(entries)
    .sort((a, b) => (entries[b].fecha || '').localeCompare(entries[a].fecha || ''))
    .map((id) => ({
      id,
      nombre: entries[id].nombre || id,
      fecha: entries[id].fecha || '',
    }));
}

export function hasProject(id) {
  return Object.prototype.hasOwnProperty.call(readAll(), id);
}

/** Guarda o reemplaza. `false` si el almacenamiento está lleno. */
export function saveProject(id, data, now = new Date()) {
  const entries = readAll();
  entries[id] = { nombre: id, fecha: now.toISOString(), data };
  return writeAll(entries);
}

export function loadProject(id) {
  const entry = readAll()[id];
  return entry ? entry.data : null;
}

export function deleteProject(id) {
  const entries = readAll();
  delete entries[id];
  return writeAll(entries);
}
